import React  from 'react';
import PropTypes from 'prop-types';

import DurationInput from "core/gd-ui/duration-input/duration";
import DurationWorkDaysField from "../duration-work-days";

export default function DurationWorkDaysInList(props) {

    const value = DurationWorkDaysField.getValue(props.item);

    return (
        <DurationInput className="gd-field-duration list"
                       type="list"
                       value={value}
                       placeholder="Duration work days"
                       onFocus={props.onFocus}
                       onBlur={props.onBlur}
                       disabled={props.disabled}
                       onChange={props.onChange}/>
    );
}

DurationWorkDaysInList.propTypes = {
    item: PropTypes.object,
    disabled: PropTypes.bool,

    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func
};